import { createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "modal-card" }
const _hoisted_2 = { class: "modal-card-head modal-style" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "modal-card-title has-text-white text-center" }, "Login", -1)
const _hoisted_4 = { class: "modal-card-body modal-style" }
const _hoisted_5 = { class: "field margin-t-24" }
const _hoisted_6 = { class: "control has-icons-left" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" })
], -1)
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "control has-icons-left" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "icon is-small is-left" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-lock" })
], -1)
const _hoisted_11 = {
  key: 0,
  class: "help is-danger",
  "data-testid": "login-error"
}
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center margin-t-24" }
const _hoisted_14 = { class: "text-center margin-t-12" }
const _hoisted_15 = { class: "has-text-white" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Don’t have an account ? ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: `modal ${_ctx.active ? 'is-active' : ''}`
  }, [
    _createVNode("div", {
      class: "modal-background",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('toggle-login')))
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode("header", _hoisted_2, [
        _hoisted_3,
        _createVNode("button", {
          class: "delete border-solid",
          "aria-label": "close",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle-login')))
        })
      ]),
      _createVNode("section", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.email = $event)),
              class: "input is-background-black has-text-white",
              type: "email",
              placeholder: "Email",
              "data-testid": "login-email-input"
            }, null, 512), [
              [_vModelText, _ctx.email]
            ]),
            _hoisted_7
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _withDirectives(_createVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.password = $event)),
              class: "input is-background-black has-text-white",
              placeholder: "Password",
              type: "password",
              "data-testid": "login-password-input"
            }, null, 512), [
              [_vModelText, _ctx.password]
            ]),
            _hoisted_10
          ])
        ]),
        (_ctx.error)
          ? (_openBlock(), _createBlock("p", _hoisted_11, " Incorrect email or password "))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_12, [
          _createVNode("button", {
            class: "button is-background-green no-border margin-t-24",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.login && _ctx.login(...args))),
            "data-testid": "login-submit-button"
          }, " Log in ")
        ]),
        _createVNode("div", _hoisted_13, [
          _createVNode("a", {
            class: "has-text-white",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.showPasswordDialog && _ctx.showPasswordDialog(...args)))
          }, " Forget password ? ")
        ]),
        _createVNode("div", _hoisted_14, [
          _createVNode("p", _hoisted_15, [
            _hoisted_16,
            _createVNode("a", {
              class: "has-text-white text-underline",
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showSignupDialog && _ctx.showSignupDialog(...args)))
            }, " Sign up ")
          ])
        ])
      ])
    ])
  ], 2))
}